// extracted by mini-css-extract-plugin
export default {"actionHeader":"styles_actionHeader__ZvLZ2","actionHeader_link":"styles_actionHeader_link__C2t4p"};